import React from 'react';
import styled from 'styled-components';

import LocationInfoIconSvg from '../assets/hotels/details/locationInfoIcon.svg';
import {defaultTheme} from '@stencil/build-theme';

const LocationInfoIcon = styled(LocationInfoIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || defaultTheme.colors.downriver.medium};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default LocationInfoIcon;
